// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"485fe539","663":"f363ad2a","783":"a673ce01","807":"9c37cf4c","819":"fe4b6ff3","967":"41f413fe"}[chunkId] + ".chunk.js";
};